export default [
  {
    path: '/vehicle_policy/:type(0|1|2|3)',
    component: () => import('@/views/policy/VehiclePolicy'),
    props: true,
    meta: { title: '保单查询', componentName: 'VehiclePolicy' },
    children: [
      {
        path: '/vehicle_policy/detail/:id',
        component: () => import('@/views/policy/VehiclePolicyDetail'),
        props: true,
        meta: { title: '保单详情' }
      },
      {
        path: '/policy_modify_create/:id',
        component: () => import('@/views/policy/PolicyModifyCreate'),
        props: true,
        meta: { title: '保单保全' }
      },
      {
        path: '/vehicle_policy_add/:id',
        component: () => import('@/views/policy/VehiclePolicyEntry'),
        props: route => ({
          type: 'add',
          id: route.params.id
        }),
        meta: { title: '增保' }
      },
      {
        path: '/vehicle_policy_reduce/:id',
        component: () => import('@/views/policy/VehiclePolicyEntry'),
        props: route => ({
          type: 'reduce',
          id: route.params.id
        }),
        meta: { title: '减保' }
      }
    ]
  },
  {
    path: '/vehicle_policy_draft',
    component: () => import('@/views/policy/VehiclePolicyDraft'),
    meta: { title: '手工录单', componentName: 'VehiclePolicyDraft' },
    children: [
      {
        path: '/vehicle_policy_entry',
        component: () => import('@/views/policy/VehiclePolicyEntry'),
        props: () => ({
          draftId: ''
        }),
        meta: { title: '新建手工录单' }
      },
      {
        path: '/vehicle_policy_entry/:draftId',
        component: () => import('@/views/policy/VehiclePolicyEntry'),
        props: true,
        meta: { title: '编辑手工录单' }
      }
    ]
  },
  {
    path: '/policy_draft_all',
    component: () => import('@/views/policy/VehiclePolicyDraft'),
    props: () => ({
      isDraftAll: true
    }),
    meta: { title: '全部手工录单', componentName: 'VehiclePolicyDraft' },
    children: [
      {
        path: '/vehicle_policy_entry_all',
        component: () => import('@/views/policy/VehiclePolicyEntry'),
        props: () => ({
          draftId: '',
          isDraftAll: true
        }),
        meta: { title: '新建手工录单' }
      },
      {
        path: '/vehicle_policy_entry_all/:draftId',
        component: () => import('@/views/policy/VehiclePolicyEntry'),
        props: route => ({
          draftId: route.params.draftId,
          isDraftAll: true
        }),
        meta: { title: '编辑手工录单' }
      }
    ]
  },
  {
    path: 'claim/management',
    component: () => import('@/views/policy/ClaimManagement'),
    meta: { title: '理赔管理' }
  },
  {
    path: 'inquiry_sheet',
    component: () => import('@/views/policy/InquirySheet'),
    meta: { title: '询价单列表' }
  },
  {
    path: 'inquiry_sheet/detail/:vehicleEnquiryId',
    props: true,
    component: () => import('@/views/product/QueryDetail'),
    meta: { title: '询价单详情' }
  },
  {
    path: '/vehicle_policy_service',
    component: () => import('@/views/policy/VehiclePolicy'),
    props: route => ({
      type: route.params.type,
      isService: true
    }),
    meta: { title: '保单列表', componentName: 'VehiclePolicy' },
    children: [
      {
        path: '/vehicle_policy_service/:id',
        component: () => import('@/views/policy/VehiclePolicyDetail'),
        props: route => ({
          type: route.params.type,
          id: route.params.id,
          isService: true
        }),
        meta: { title: '保单详情' }
      }
    ]
  },
  {
    path: 'policy_info_collection',
    component: () => import('@/views/policy/PolicyInfoCollection'),
    meta: { title: '出单信息采集' },
    children: [
      {
        path: 'detail/:id',
        component: () => import('@/views/policy/PolicyInfoCollectionDetail'),
        props: true,
        meta: { title: '出单信息采集详情' }
      }
    ]
  },
  // 非车险保单
  {
    path: 'general_policy',
    component: () => import('@/views/policy/GeneralPolicy'),
    meta: { title: '非车险保单' },
    children: [
      {
        path: 'detail/:id',
        component: () => import('@/views/policy/GeneralPolicyDetail'),
        props: true,
        meta: { title: '非车险保单详情' }
      },
      {
        path: 'add/:nonVehPolicyId',
        component: () => import('@/views/policy/GeneralPolicyEntry'),
        props: route => ({
          nonVehPolicyId: route.params.nonVehPolicyId,
          type: 'add'
        }),
        meta: { title: '非车险保单增保' }
      },
      {
        path: 'reduce/:nonVehPolicyId',
        component: () => import('@/views/policy/GeneralPolicyEntry'),
        props: route => ({
          nonVehPolicyId: route.params.nonVehPolicyId,
          type: 'reduce'
        }),
        meta: { title: '非车险保单减保' }
      },
      {
        path: 'modify/:nonVehPolicyId',
        component: () => import('@/views/policy/GeneralPolicyModifyCreate'),
        props: route => ({
          nonVehPolicyId: route.params.nonVehPolicyId,
          type: 'add'
        }),
        meta: { title: '非车险保单保全' }
      }
    ]
  },
  // 非车险保单草稿
  {
    path: '/general_policy_draft',
    component: () => import('@/views/policy/GeneralPolicyDraft'),
    meta: { title: '非车险保单草稿' },
    children: [
      {
        path: '/general_policy_entry',
        component: () => import('@/views/policy/GeneralPolicyEntry'),
        props: () => ({
          draftId: ''
        }),
        meta: { title: '新建非车险保单草稿' }
      },
      {
        path: '/general_policy_entry/:draftId',
        component: () => import('@/views/policy/GeneralPolicyEntry'),
        props: true,
        meta: { title: '编辑非车险保单草稿' }
      }
    ]
  }
]
